import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ThunderstormRoundedIcon from '@mui/icons-material/ThunderstormRounded';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export default function CardAlert({ conditions }) {
  const theme = useTheme();

  const trendColors = {
    high: theme.palette.mode === 'light' ? theme.palette.error.main : theme.palette.error.dark,
    low: theme.palette.mode === 'light' ? theme.palette.success.main : theme.palette.success.dark,
    moderate: theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700],
  };

  const color = trendColors[conditions] || theme.palette.text.primary; // Default color if conditions are unknown
  const labelConditions = { high: 'high', low: 'low', moderate: 'moderate' };
  const labelRisk = labelConditions[conditions] || 'unknown'; // Fallback for undefined conditions

  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent>
        <ThunderstormRoundedIcon fontSize="small" />
        <Typography gutterBottom sx={{ fontWeight: 600 }}>
          Current conditions
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          Hazard threats are{' '}
          <Typography component="span" sx={{ fontWeight: 'bold', color }}>
            {labelRisk}
          </Typography>
          .
        </Typography>
        <Link to="/hazards" style={{ textDecoration: 'none' }}>
        <Button variant="contained" size="small" fullWidth>
          See hazards
        </Button>
        </Link>
      </CardContent>
    </Card>
  );
}
